import * as types from 'generated/graphql';
import { ITypeSpecificPolicy } from './shared';
import { dateTimeFieldPolicy } from './fieldPolicies';



export const Milestone: ITypeSpecificPolicy<types.Milestone> = {

  fields: {
    estimatedStartDate: dateTimeFieldPolicy(),
    startDate: dateTimeFieldPolicy(),
    endDate: dateTimeFieldPolicy()
  }

};
